/**
 * 子账号-系统开通记录(角色)
 * @type {string}
 */
export const USER_SUB_ROLE_LIST = "/ucenter-customer/user/sub/role/list";
/**
 * 小二-角色列表
 * @type {string}
 */
export const WAITER_ROLE_LIST = "/ucenter-admin/waiter/role/list";
